import React from "react";
import { ReactComponent as Arrow } from "svgs/small-right-arrow.svg";
import { ReactComponent as PlusIcon } from "svgs/plus.svg";
import { ReactComponent as MinusIcon } from "svgs/minus.svg";
import clsx from "clsx/lite";

const Icons = ({ arrowIcons, isOpen, iconClass }) => {
	if (arrowIcons) {
		return (
			<Arrow className={clsx(isOpen ? "-rotate-90" : "rotate-90", iconClass)} />
		);
	}

	return (
		<div className={clsx("p-4 rounded-full cursor-pointer bg-black", isOpen && "bg-grey")}>
			<div className="size-3 flex justify-center items-center">
				{isOpen ? <MinusIcon className="fill-black " /> 
					: <PlusIcon className="invert" />}
			</div>
		</div>
	);
};



const Collapsible = ({
	title, isOpen, setIsOpen, children, arrowIcons = true,
	className = "", titleClass = "", contentClass = "", label, iconClass
}) => (
	<div
		className={clsx(className, "flex flex-col gap-3")}
	>
		<button
			className={clsx(titleClass, "flex w-full justify-between items-center gap-1")}
			onClick={setIsOpen}
			aria-expanded={isOpen ? "true" : "false"}
			aria-label={label}
		>
			{title}
			<div className="w-fit">
				<Icons arrowIcons={arrowIcons} isOpen={isOpen} iconClass={iconClass} />
			</div>
		</button>
		<div
			className={clsx(
				"overflow-hidden transition-all duration-500 ease-in-out",
				contentClass,
				isOpen ? "max-h-160 opacity-1" : "max-h-0 opacity-0")}
		>
			{children}
		</div>
	</div >
);

export default Collapsible;